"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getHeightOfDate;

var _ = require(".");

function getHeightOfDate(date) {
  var clone = new Date(date);
  return (0, _.getHeightOfMinutes)(clone.getHours() * 60 + clone.getMinutes());
}